export function formatCurrency(val: number): string {
  const abs = Math.abs(val);
  let str: string;
  if (abs >= 1e7) str = "₹" + (abs / 1e7).toFixed(2) + "Cr";
  else if (abs >= 1e5) str = "₹" + (abs / 1e5).toFixed(2) + "L";
  else if (abs >= 1000) str = "₹" + abs.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  else str = "₹" + abs.toFixed(2);
  return val < 0 ? "-" + str : str;
}

export function formatNum(val: number, decimals = 4): string {
  if (Math.abs(val) < 1e-6) return "~0";
  const abs = Math.abs(val);
  if (abs >= 1e6) return (val / 1e6).toFixed(2) + "M";
  if (abs >= 1e3) return val.toFixed(2);
  return val.toFixed(decimals);
}

export function formatPrice(val: number): string {
  if (val >= 1000) return "₹" + val.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (val >= 1) return "₹" + val.toFixed(2);
  return "₹" + val.toFixed(6);
}